import React from "react";
import AccountAccess from "../components/AccountAccess";
import { Route, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Header from "components/Header/index";
import Sidebar from "containers/SideNav/index";

import Inicio from "./routes/inicio";
import Series from "./routes/series";

import Videos from "./routes/videos";
import Gpt from "./routes/gpts";

import SelectTraining from "./routes/selecttraining";

import Preguntas from "./routes/preguntas";
import Crm from "./routes/crm";

import Manuales from "./routes/manuales";
import { withOneTabEnforcer } from "react-one-tab-enforcer";
import Prensa from "./routes/prensa";

import Webinars from "./routes/webinars";
import Libros from "./routes/libros";
import Documentos from "./routes/documentos";
import ExtraPages from "./routes/extraPages";

import SidenavContent from "../containers/SideNav/SidenavContent";

import GeneralApi from "./generalApi";
const apiGeneral = new GeneralApi();

import { Row, Col, Divider } from "antd";
import "antd/dist/antd.css";

import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
} from "constants/ActionTypes";

import { isIOS, isMobile } from "react-device-detect";
import asyncComponent from "../util/asyncComponent";
import TopNav from "components/TopNav";

const TRUE_VALUE = true;

class App extends React.Component {
  constructor(props) {
    super(props);
  }

  isMobileDevice() {
    return window.innerWidth <= 1080;
  }

  render() {
    const { match, drawerType, navigationStyle, horizontalNavPosition } =
      this.props;

    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && (isMobile || this.isMobileDevice())) {
      document.body.classList.add("ios-mobile-view-height");
    } else if (document.body.classList.contains("ios-mobile-view-height")) {
      document.body.classList.remove("ios-mobile-view-height");
    }
    return (
      <div
        className={`app-container ${
          this.isMobileDevice() ? "collapsible-drawer" : "fixed-drawer"
        }`}
      >
        <AccountAccess automatic routePath={this.props.location.pathname} />
        <Sidebar />
        <div className="app-main-container">
          <div className="app-header">
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === ABOVE_THE_HEADER && (
                <TopNav styleName="app-top-header" />
              )}
            <Header />
            {navigationStyle === HORIZONTAL_NAVIGATION &&
              horizontalNavPosition === BELOW_THE_HEADER && <TopNav />}
          </div>

          <main
            className="app-main-content-wrapper"
            style={{ overflow: "hidden" }}
          >
            <Row>
              <Col
                xs={{ span: 0, offset: 0 }}
                sm={{ span: 0, offset: 0 }}
                md={{ span: 0, offset: 0 }}
                lg={{ span: 0, offset: 0 }}
                xl={{ span: 5, offset: 0 }}
                xxl={{ span: 5, offset: 0 }}
                style={{ overflow: "hidden" }}
              >
                {" "}
                <div
                  className="side-nav"
                  style={{
                    backgroundColor:
                      apiGeneral.getBackgroundColor() + " !important",
                  }}
                >
                  <SidenavContent />
                </div>
              </Col>

              <Col
                xs={{ span: 24, offset: 0 }}
                sm={{ span: 24, offset: 0 }}
                md={{ span: 24, offset: 0 }}
                lg={{ span: 24, offset: 0 }}
                xl={{ span: 19, offset: 0 }}
                xxl={{ span: 19, offset: 0 }}
              >
                <div className="app-main-content" style={{ height: "100vh" }}>
                  <Switch>
                    <Route path={`${match.url}/inicio`} component={Inicio} />
                    <Route path={`${match.url}/videos`} component={Videos} />
                    <Route path={`${match.url}/gpts`} component={Gpt} />
                    <Route
                      path={`${match.url}/manuales`}
                      component={Manuales}
                    />

                    <Route path={`${match.url}/series`} component={Series} />

                    <Route
                      path={`${match.url}/selecttraining`}
                      component={SelectTraining}
                    />

                    <Route
                      path={`${match.url}/preguntas`}
                      component={Preguntas}
                    />

                    <Route
                      path={`${match.url}/webinars`}
                      component={Webinars}
                    />

                    <Route path={`${match.url}/prensa`} component={Prensa} />
                    <Route path={`${match.url}/libros`} component={Libros} />
                    <Route
                      path={`${match.url}/documentos`}
                      component={Documentos}
                    />

                    <Route path={`${match.url}/`} component={ExtraPages} />

                    <Route
                      component={asyncComponent(() =>
                        import("app/routes/extraPages/routes/404")
                      )}
                    />
                  </Switch>
                </div>
              </Col>
            </Row>
          </main>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ settings }) => {
  const { drawerType, navigationStyle, horizontalNavPosition } = settings;
  return { drawerType, navigationStyle, horizontalNavPosition };
};
//export default withRouter(connect(mapStateToProps)(App));

const DifferentWarningComponent = () => (
  <div style={{ width: "100vw" }}>
    <h1 style={{ textAlign: "center", marginTop: "50px" }}>
      Lo sentimos, solo puedes tener Escuelapp abierta en una sola pestaña
    </h1>
  </div>
);
export default withRouter(connect(mapStateToProps)(App));



// WEBPACK FOOTER //
// ./app/index.js